import { Platform, Alert, Linking } from 'react-native';

export interface PermissionResult {
  granted: boolean;
  neverAskAgain?: boolean;
}

// Web-compatible permissions module
// Most permissions are not applicable in web browsers - browser handles them automatically

export class PermissionManager {
  /**
   * Request camera permission
   */
  static async requestCameraPermission(): Promise<PermissionResult> {
    // On web, browser will prompt automatically when camera is accessed
    return { granted: true };
  }

  /**
   * Request gallery/media permission
   */
  static async requestGalleryPermission(): Promise<PermissionResult> {
    // On web, file access is handled through file input elements
    return { granted: true };
  }

  /**
   * Request video permission (for Android 13+)
   */
  static async requestVideoPermission(): Promise<PermissionResult> {
    // On web, file access is handled through file input elements
    return { granted: true };
  }

  /**
   * Request all media permissions (images + videos for Android 13+)
   */
  static async requestMediaPermissions(): Promise<PermissionResult> {
    // On web, file access is handled through file input elements
    return { granted: true };
  }

  /**
   * Show settings dialog when permission is permanently denied
   */
  private static showSettingsDialog(permissionType: string) {
    Alert.alert(
      `${permissionType} Permission Required`,
      `${permissionType} access was denied. Please check your browser settings.`,
      [
        { text: "Cancel", style: "cancel" },
        { 
          text: "OK", 
          onPress: () => {
            // On web, we can't open system settings
            console.log('Please check your browser settings for permissions');
          }
        }
      ]
    );
  }

  /**
   * Check if all required permissions are granted
   */
  static async checkAllPermissions(): Promise<{
    camera: boolean;
    gallery: boolean;
    video: boolean;
  }> {
    // On web, assume permissions are available (browser will prompt when needed)
    return { camera: true, gallery: true, video: true };
  }
}

export default PermissionManager;
